
import { Component, Vue } from 'vue-property-decorator'
import Modal from '@/components/Modal/Modal.vue'
import RegisterSongStep0SelectACatalog from '@/views/IntellectualProperty/RegisterSongs/RegisterSongStep0SelectACatalog.vue';
import RegisterSongStep4Done from '@/views/IntellectualProperty/RegisterSongs/RegisterSongStep4Done.vue';
import { RegisterSongService } from '@/services/RegisterSongService';
import { RequestType } from '@/configs/SongRegistrationConfig';
import { BusyService } from '@/services/BusyService';
import { ToastService } from '@/services/ToastService';
import CatalogHelpIcon from './../RegisterSongs/CatalogHelpIcon.vue';
import { bus, i18n } from '@/main';


@Component({ 
  components:{ 
    Modal,
    RegisterSongStep0SelectACatalog, 
    CatalogHelpIcon, 
    RegisterSongStep4Done
  }
})
export default class EditSongOwnershipModal extends Vue {
  init = false;
  store = RegisterSongService;
  completed = false;

  async show() { 
    BusyService.showBusy();
    await RegisterSongService.loadEditSong(
      this.$route.params.ccliSongId, 
      RequestType.EditSongOwnership,
      this.onClose, 
    );
    this.init = true;
    this.completed = false;
    BusyService.hideBusy();
    (this.$refs.modal as Modal).show();
  }

  onClose(){ 
    (this.$refs.modal as Modal).hide();
    this.init = false;
  }
  async onSave(){ 
    try{
      await RegisterSongService.save();
      ToastService.successToast(this.$t('R.MES_SongChangesSaved').toString());
      bus.$emit('refreshSong');
      this.init = false;
      this.completed = true;
    }catch(err){ 
      ToastService.dangerToast(this.$t('R.MES_ServerError').toString());
      throw err;
    }
    (this.$refs.modal as Modal).scrollToTop();
  }
}
